<template>
  <div class="upload-oss">
    <el-upload
      class="upload-demo"
      :action="actionUrl"
      :headers="headers"
      :file-list="fileList"
      :accept="accept"
      :multiple="false"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-remove="handleRemove"
      :show-file-list="false"
    >
      <el-button size="small" type="primary" :loading="loading">
        {{ loading ? '上传中...' : (modelValue ? '重新上传' : '点击上传') }}
      </el-button>
      <span v-if="modelValue" class="file-name">{{ fileName }}</span>
    </el-upload>

    <el-progress
      v-if="loading"
      :percentage="uploadProgress"
      :show-text="false"
      stroke-width="2"
      class="upload-progress"
    ></el-progress>
  </div>
</template>

<script>
import { Message } from 'element-ui'

export default {
  name: 'UploadOss',
  props: {
    value: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择文件'
    },
    accept: {
      type: String,
      default: '.pdf,.docx,.doc'
    },
    uploadUrl: {
      type: String,
      default: '/article/oss/upload'
    },
    targetServer: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      uploadProgress: 0,
      fileList: [],
      fileName: '',
      originalFileName: '' // 保存原始文件名
    }
  },
  computed: {
    actionUrl() {
      // 如果指定了目标服务器，使用完整路径
      if (this.targetServer) {
        return this.targetServer + this.uploadUrl
      }
      // 开发环境使用代理，生产环境使用相对路径
      return this.uploadUrl
    },
    headers() {
      return {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Project-Id': localStorage.getItem('projectId') || ''
      }
    }
  },
  watch: {
    modelValue(val) {
      if (val) {
        const urlParts = val.split('/')
        this.fileName = urlParts[urlParts.length - 1] || '已上传文件'
      } else {
        this.fileName = ''
      }
    }
  },
  mounted() {
    if (this.modelValue) {
      const urlParts = this.modelValue.split('/')
      this.fileName = urlParts[urlParts.length - 1] || '已上传文件'
    }
  },
  methods: {
    beforeUpload(file) {
      const isAllowed = this.accept.includes(file.name.substring(file.name.lastIndexOf('.')))
      if (!isAllowed) {
        Message.error(`请上传 ${this.accept} 格式的文件`)
        return false
      }

      const isLt20M = file.size / 1024 / 1024 < 50
      if (!isLt20M) {
        Message.error('上传文件大小不能超过 50MB')
        return false
      }

      this.loading = true
      this.uploadProgress = 0
      return true
    },

    handleSuccess(response, file, fileList) {
      this.loading = false
      this.uploadProgress = 100

      if (response.code === 200 && response.data) {
        const url = response.data.url || response.data.path
        // 保存原始文件名和上传后的URL
        this.originalFileName = file.name
        this.fileName = file.name
        this.$emit('input', url)
        this.$emit('update:modelValue', url)
        // 通知父组件文件名变化
        this.$emit('file-change', { name: file.name, url: url })
        Message.success('上传成功')
      } else {
        Message.error(response.msg || '上传失败')
      }
    },

    handleError(err, file, fileList) {
      this.loading = false
      Message.error('上传失败：' + (err.message || '网络错误'))
    },

    handleRemove(file, fileList) {
      this.$emit('input', '')
      this.$emit('update:modelValue', '')
      this.fileName = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-oss {
  display: inline-flex;
  align-items: center;
  gap: 12px;

  .file-name {
    font-size: 13px;
    color: #666;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .upload-progress {
    width: 150px;
    margin-top: 8px;
  }
}
</style>